import { Type } from "lucide-react";
import React from "react";
import { TextShape } from "../../../../../../types";
import { EditorSelect } from "../../../../../ui/EditorSelect";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "../../../../../ui/popover";
import { useMapEditorActions } from "../../../../contexts/MapEditorContext";

export interface ShapeToolboxTextItemsProps {
  shape: TextShape;
}

export const ShapeToolboxTextItems: React.FC<ShapeToolboxTextItemsProps> = ({
  shape
}) => {
  const { updateShape } = useMapEditorActions();

  const handleFontSizeChange = (value: string) => {
    if (shape.type === "text") {
      updateShape(shape.id, { fontSize: Number.parseInt(value, 10) });
    }
  };

  const _handleFontFamilyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (shape.type === "text") {
      updateShape(shape.id, { fontFamily: e.target.value });
    }
  };

  return (
    <>
      <div className="h-4 w-px bg-neutral-200" />
      <Popover>
        <PopoverTrigger asChild>
          <button
            className="flex items-center gap-1 rounded p-1 transition-colors hover:bg-neutral-100"
            title="Text Options"
          >
            <Type size={16} className="text-neutral-600" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-64 p-3" align="start" side={"top"}>
          <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-1">
              <div className="font-medium text-sm">Font Size</div>
              <EditorSelect
                label="Font size"
                value={String((shape as TextShape).fontSize)}
                onValueChange={handleFontSizeChange}
                className="h-7 w-auto min-w-16"
                options={[
                  12, 14, 16, 18, 20, 24, 28, 32, 36, 40, 48, 56, 64, 72
                ].map((size) => ({ value: String(size), label: `${size}px` }))}
              />
            </div>
            {/*<div className="flex flex-col gap-1">
              <div className="text-sm font-medium">Font Family</div>
              <select
                value={(shape as TextShape).fontFamily}
                onChange={handleFontFamilyChange}
                className="w-full rounded-md border border-neutral-200 p-2"
              >
                {[
                  'Arial',
                  'Times New Roman',
                  'Helvetica',
                  'Courier New',
                  'Georgia',
                  'Verdana',
                  'Impact'
                ].map((font) => (
                  <option key={font} value={font}>
                    {font}
                  </option>
                ))}
              </select>
            </div>*/}
          </div>
        </PopoverContent>
      </Popover>
    </>
  );
};
